import React, { useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";

import * as Constants from "../../../../../constants/Constants";
import OnSubmitErrorMessage from "../../../../Common/Errors/OnSubmitErrorMessage";
import "./DenyRequest.css";

const DenyRequest = ({
    show,
    denyData,
    approveDenyRequest,
    handleCloseDenyRequest,
    errorStatus,
    errorMsg
}) => {
    const [reasonReject, setReasonReject] = useState("");

    const setReasonValue = (event) => {
        const charCount = event.target.value?.length;
        const charLeft = 501 - charCount;

        charLeft > 0 && setReasonReject(event.target.value);
    };

    const handleDenyRequest = () => approveDenyRequest(Constants.REJECTED, reasonReject);

    return (
        <Modal
            show={show}
            onHide={handleCloseDenyRequest}
            contentClassName="denyModal"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {denyData?.requestType === Constants.ACCESS_REQUEST ?
                        Constants.ACCESS_REQUEST + " "
                        : denyData?.requestType === Constants.NEW_VENDOR_RECORD ?
                            Constants.NEW_VENDOR_RECORD + " "
                            : ""
                    }
                    - {Constants.DENY_REQUEST}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="denyModalBodyFormGroup">
                        <Form.Label className="denyModalBodyFormValueText">Are you sure you wish to deny this vendor’s request?</Form.Label>
                    </Form.Group>
                    <Form.Group className="denyModalBodyFormGroup">
                        <Form.Label className="denyModalBodyFormLabel">Vendor Name:</Form.Label>
                        <Form.Label className="denyModalBodyFormValue">{denyData?.vendorName}</Form.Label>
                    </Form.Group>
                    <Form.Group className="denyModalBodyFormGroup">
                        <Form.Label className="denyModalBodyFormLabel">Vendor Email:</Form.Label>
                        <Form.Label className="denyModalBodyFormValue">{denyData?.userEmail}</Form.Label>
                    </Form.Group>
                    <Form.Group className="denyModalBodyFormGroup">
                        <Form.Label className="denyModalBodyFormLabel">Merchant Email:</Form.Label>
                        <Form.Label className="denyModalBodyFormValue">{denyData?.merchantEmail}</Form.Label>
                    </Form.Group>
                    <Form.Group className="denyModalBodyFormGroup">
                        <Form.Label className="denyModalBodyFormValueText">Please enter reason for rejection<span className="required">*</span></Form.Label>
                    </Form.Group>
                    <Form.Group className="denyModalBodyFormGroup">
                        <Form.Control
                            as="textarea"
                            placeholder="The text in this box will be sent to the vendor via email."
                            style={{ height: "100px", fontSize: "13px" }}
                            value={reasonReject}
                            onChange={(e) => setReasonValue(e)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <div className="denyModalFooterContent">
                    <Button
                        variant="primary"
                        className="button-primary-md"
                        onClick={handleDenyRequest}
                        disabled={reasonReject === ""}
                    >
                        {Constants.SUBMIT_BUTTON}
                    </Button>
                </div>
                <div className="denyModalFooterContent">
                    {errorStatus && (
                        <OnSubmitErrorMessage
                            type="error"
                            message={errorMsg}
                        />
                    )}
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default DenyRequest;
